import * as Sentry from '@sentry/browser';

export const throwAndLogPreviewError = (error: Error): never => {
  Sentry.captureMessage(`Error previewing price for Billing 3.0: ${error}`);
  Sentry.captureException(error);
  throw error;
};
